import { useTranslation } from "react-i18next";
import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

interface Review {
  id: string;
  rating: number;
  comment: string;
  products: {
    id: string;
    name: string;
    brand: string;
    image_url: string | null;
  };
}

interface ProfileReviewsProps {
  reviews: Review[];
  isLoading?: boolean;
  isAuthenticated: boolean;
}

const ProfileReviews = ({ reviews, isLoading, isAuthenticated }: ProfileReviewsProps) => {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className="space-y-4 mt-8">
        <Skeleton className="h-32 w-full" />
        <Skeleton className="h-32 w-full" />
        <Skeleton className="h-32 w-full" />
      </div>
    );
  }

  if (!reviews.length) {
    return (
      <Card className="p-6 text-center mt-8">
        <p className="text-muted-foreground">{t('profile.noReviews')}</p>
      </Card>
    );
  }

  return (
    <div className="space-y-4 mt-8">
      {reviews.map((review) => (
        <Card key={review.id} className="p-4">
          <div className="flex items-start gap-4">
            {review.products.image_url && (
              <img
                src={review.products.image_url}
                alt={review.products.name}
                className="w-20 h-20 object-cover rounded"
              />
            )}
            <div className="flex-grow">
              <h3 className="font-semibold">{review.products.name}</h3>
              <p className="text-sm text-muted-foreground">{review.products.brand}</p>
              <div className="mt-2">
                <p>{review.comment}</p>
              </div>
            </div>
            <div className="text-lg font-semibold">
              {review.rating}/5
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
};

export default ProfileReviews;